import { currentUser } from "@homebound/auth-components";
import { useEffect, useState } from "react";

/** Resolves Amplify `currentUser()` once on mount. Shared by AppShell / GuestShell / NotFoundShell. */
export function useAuthSession() {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    onLoad().catch(console.error);
    async function onLoad() {
      const { data: user } = await currentUser();
      setIsAuthenticated(user !== undefined);
      setIsAuthenticating(false);
    }
  }, []);

  return { isAuthenticating, isAuthenticated };
}
